import {combineReducers, Reducer} from 'redux';
import {FETCH_EXPERIMENTS, _SUCCESS} from './reducers-const';

export type Experiment = '';

const active: Reducer<Experiment[]> = (state: Experiment[] = [], action) => {
  switch (action.type) {
    case `${FETCH_EXPERIMENTS}${_SUCCESS}`:
      return action.data;
    default:
      return state;
  }
};

export type Experiments = {
  active: Experiment[]
};

export default combineReducers<Experiments>({
  active
});
